import { render } from "./DeleteContentModal.vue?vue&type=template&id=4d4e8396"
import script from "./DeleteContentModal.vue?vue&type=script&lang=js"
export * from "./DeleteContentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__